module.exports = __webpack_public_path__ + "img/6.bc8c47c6.jpg";